import { render } from "./RegisterProd.vue?vue&type=template&id=05ab115b&scoped=true"
import script from "./RegisterProd.vue?vue&type=script&lang=js"
export * from "./RegisterProd.vue?vue&type=script&lang=js"

import "./RegisterProd.vue?vue&type=style&index=0&id=05ab115b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ab115b"]])

export default __exports__